import NameCell from './NameCell';
import type { TeamTableColumns } from '../hooks/useTeamsColumns';

interface CellProps {
  rowData: TeamTableColumns;
}

export default function TeamsPageNameCell({ rowData }: CellProps) {
  const hasNoAccounts =
    !rowData.platformAccounts || rowData.platformAccounts.length === 0;

  return <NameCell rowData={rowData} disabled={hasNoAccounts} />;
}
